import { useEffect, useState } from "react";

export enum ObjektTyp {
    Kst = 0,
    Prj = 1,
    Objekt3 = 2,
    Objekt4 = 3,
    Kvantitet = 4
}

function toCamelCase(str: string) {
    return str[0].toLowerCase() + str.substr(1);
}

export interface KonteringsTypOptions {
    typ: ObjektTyp;
    använder: boolean;
    kortNamn: string;
    namn: string;
    getShortName: () => string;
}

const DefaultColumnHeaders = {} as Record<string, string>;
DefaultColumnHeaders[toCamelCase(ObjektTyp[ObjektTyp.Kst])] = "K";
DefaultColumnHeaders[toCamelCase(ObjektTyp[ObjektTyp.Prj])] = "P";
DefaultColumnHeaders[toCamelCase(ObjektTyp[ObjektTyp.Objekt3])] = "Obj3";
DefaultColumnHeaders[toCamelCase(ObjektTyp[ObjektTyp.Objekt4])] = "Obj4";

export interface KonteringsOptions {
    konteringsTyper: Record<string, KonteringsTypOptions>;
    get: (typ: ObjektTyp) => KonteringsTypOptions;
    getUse: (typ: ObjektTyp) => boolean;
    getShortName: (typ: ObjektTyp) => string;
}

function parseData(data: any): KonteringsOptions {
    const retval = {} as KonteringsOptions;

    if (!data)
        return retval;

    retval.konteringsTyper = data.konteringsTyper;

    for (const [k, v] of Object.entries(retval.konteringsTyper)) {
        retval.konteringsTyper[k].getShortName = () => v.kortNamn || DefaultColumnHeaders[k];
    }
    retval.get = (typ: ObjektTyp) => { 
        return retval.konteringsTyper && retval.konteringsTyper[toCamelCase(ObjektTyp[typ])] 
    };
    retval.getUse = (typ: ObjektTyp) => retval.get(typ)?.använder;
    retval.getShortName = (typ: ObjektTyp) => retval.get(typ)?.kortNamn || DefaultColumnHeaders[typ];
    return retval;
}

// window.KonteringsOptions är ett serialiserat objekt i VisaFaktura.aspx. Det serialiseras till camelCase.
export function useKonteringsOptions() {
    const [data, setData] = useState<KonteringsOptions | undefined>(null);

    useEffect(() => {
        const tmp = parseData(window.KonteringsOptions);
        setData(tmp);
    }, [window.JSRpcPlaner]);

    return data;
}
